<template>
    <div>
        <section class="breadcrumb-section decoration_top_section">
            <div class="container">
                <nav aria-label="breadcrumb">
                    <ol class="breadcrumb">
                        <li class="breadcrumb-item">
                            <router-link to="/">Home</router-link>
                        </li>
                        <li class="breadcrumb-item active" aria-current="page">
                            {{ page_title }}
                        </li>
                    </ol>
                </nav>
                <h1 class="main_title" style="text-align: center">
                    <span>{{ page_title }}</span>
                </h1>
            </div>
        </section>

        <section class="cmn-section brand_page p-0" v-if="banner_image">
            <img :src="banner_image" alt="brand-image" />
        </section>
        <section class="decoration_text_banner">
            <div class="container">
                <div class="text-box">
                    <h2>Time is Money</h2>
                    <p>
                        Our new simplified decoration pricing save you both.
                        <span>View Decoration Pricing</span>
                    </p>
                    <h3>So many ways to make your logo look great</h3>
                </div>
            </div>
        </section>
        <section class="cmn-section decoration-section">
            <div class="container">
                <div class="row brand_row">
                    <div class="col-md-3 col-sm-6">
                        <div class="decoration-product brand_col">
                            <img
                                src="/maincss/images/Decoration_1.png"
                                alt=""
                            />
                            <div class="brand_overlay">
                                <h2 class="overlay_heading">
                                    Direct To Garment
                                </h2>
                                <p>
                                    A superior alternative to screen printing
                                    for tees, hoodies and other cotton-fleece
                                    styles,
                                </p>
                                <div class="overlay_btn">
                                    <a target="__blank" class="view_btn"
                                        >SHOP DDTG</a
                                    >
                                    <a target="__blank" class="size_btn"
                                        >READ MORE</a
                                    >
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-3 col-sm-6">
                        <div class="decoration-product brand_col">
                            <img
                                src="/maincss/images/Decoration_2.png"
                                alt=""
                            />
                            <div class="brand_overlay">
                                <h2 class="overlay_heading">Direct To Film</h2>
                                <p>
                                    A superior alternative to screen printing
                                    for tees, hoodies and other cotton-fleece
                                    styles,
                                </p>
                                <div class="overlay_btn">
                                    <a target="__blank" class="view_btn"
                                        >SHOP DDTG</a
                                    >
                                    <a target="__blank" class="size_btn"
                                        >READ MORE</a
                                    >
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-3 col-sm-6">
                        <div class="decoration-product brand_col">
                            <img
                                src="/maincss/images/Decoration_3.png"
                                alt=""
                            />
                            <div class="brand_overlay">
                                <h2 class="overlay_heading">Screen Printing</h2>
                                <p>
                                    A superior alternative to screen printing
                                    for tees, hoodies and other cotton-fleece
                                    styles,
                                </p>
                                <div class="overlay_btn">
                                    <a target="__blank" class="view_btn"
                                        >SHOP DDTG</a
                                    >
                                    <a target="__blank" class="size_btn"
                                        >READ MORE</a
                                    >
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-3 col-sm-6">
                        <div class="decoration-product brand_col">
                            <img
                                src="/maincss/images/Decoration_4.png"
                                alt=""
                            />
                            <div class="brand_overlay">
                                <h2 class="overlay_heading">Sublimation</h2>
                                <p>
                                    A superior alternative to screen printing
                                    for tees, hoodies and other cotton-fleece
                                    styles,
                                </p>
                                <div class="overlay_btn">
                                    <a target="__blank" class="view_btn"
                                        >SHOP DDTG</a
                                    >
                                    <a target="__blank" class="size_btn"
                                        >READ MORE</a
                                    >
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-3 col-sm-6">
                        <div class="decoration-product brand_col">
                            <img
                                src="/maincss/images/Decoration_5.png"
                                alt=""
                            />
                            <div class="brand_overlay">
                                <h2 class="overlay_heading">Embroidery</h2>
                                <p>
                                    A superior alternative to screen printing
                                    for tees, hoodies and other cotton-fleece
                                    styles,
                                </p>
                                <div class="overlay_btn">
                                    <a target="__blank" class="view_btn"
                                        >SHOP DDTG</a
                                    >
                                    <a target="__blank" class="size_btn"
                                        >READ MORE</a
                                    >
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-3 col-sm-6">
                        <div class="decoration-product brand_col">
                            <img
                                src="/maincss/images/Decoration_6.png"
                                alt=""
                            />
                            <div class="brand_overlay">
                                <h2 class="overlay_heading">Patches</h2>
                                <p>
                                    A superior alternative to screen printing
                                    for tees, hoodies and other cotton-fleece
                                    styles,
                                </p>
                                <div class="overlay_btn">
                                    <a target="__blank" class="view_btn"
                                        >SHOP DDTG</a
                                    >
                                    <a target="__blank" class="size_btn"
                                        >READ MORE</a
                                    >
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-3 col-sm-6">
                        <div class="decoration-product brand_col">
                            <img
                                src="/maincss/images/Decoration_7.png"
                                alt=""
                            />
                            <div class="brand_overlay">
                                <h2 class="overlay_heading">Deboss</h2>
                                <p>
                                    A superior alternative to screen printing
                                    for tees, hoodies and other cotton-fleece
                                    styles,
                                </p>
                                <div class="overlay_btn">
                                    <a target="__blank" class="view_btn"
                                        >SHOP DDTG</a
                                    >
                                    <a target="__blank" class="size_btn"
                                        >READ MORE</a
                                    >
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-3 col-sm-6">
                        <div class="decoration-product brand_col">
                            <img
                                src="/maincss/images/Decoration_8.png"
                                alt=""
                            />
                            <div class="brand_overlay">
                                <h2 class="overlay_heading">Engraved</h2>
                                <p>
                                    A superior alternative to screen printing
                                    for tees, hoodies and other cotton-fleece
                                    styles,
                                </p>
                                <div class="overlay_btn">
                                    <a target="__blank" class="view_btn"
                                        >SHOP DDTG</a
                                    >
                                    <a target="__blank" class="size_btn"
                                        >READ MORE</a
                                    >
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row mt-5">
                    <div class="col-md-12">
                        <b-pagination
                            v-show="brand_length > itemsPerPage"
                            v-model="currentPage"
                            :total-rows="brand_length"
                            :per-page="itemsPerPage"
                            class="imprint_pagination"
                        ></b-pagination>
                    </div>
                </div>
            </div>
        </section>

        <div class="preloader" v-show="isLoader">
            <div class="preloader-body">
                <svg width="40" height="40" viewBox="0 0 40 40">
                    <polygon
                        class="rect"
                        points="0 0 0 40 40 40 40 0"
                    ></polygon>
                </svg>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "DecorationMethods",
    components: {},
    data() {
        return {
            page_title: "Decoration Methods & Pricing",
            currentPage: 1,
            itemsPerPage: 100,
            listConfig: [],
            brand_length: 0,
            brand_list: [],
            banner_image: `${process.env.VUE_APP_BASE_IMAGE_URL}/common_image/banner.png`,
            isLoader: false
        };
    },
    metaInfo() {
        return {
            title: this.page_title,
            titleTemplate: "%s | Imprintcity",
            meta: [
                {
                    vmid: "title",
                    name: "title",
                    content: "Brands"
                },
                {
                    vmid: "description",
                    name: "description",
                    content: "brands"
                },
                {
                    vmid: "keywords",
                    name: "keywords",
                    content: "brands"
                }
            ]
        };
    },
    mounted() {
        (this.listConfig = {
            offset: (this.currentPage - 1) * this.itemsPerPage,
            limit: this.itemsPerPage,
            sortBy: "",
            order: "ASC",
            searchKeyword: ""
        }),
            document.body.classList.remove("bg_primary_light_white");
    },
    watch: {
        currentPage(newValue) {
            this.listConfig.offset = (newValue - 1) * this.itemsPerPage;
        }
    }
};
</script>
